import { Component, OnInit } from '@angular/core';
import { RealizarConsultaService } from 'src/app/services/http/realizar-consulta.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-list-consulta-lote',
  templateUrl: './list-consulta-lote.component.html',
  styleUrls: ['./list-consulta-lote.component.scss']
})
export class ListConsultaLoteComponent implements OnInit {

  tableLoading:boolean = false;
  listaResultado = [];
  total:number= 0;
  pesquisaDataInicio: any;
  pesquisaDataFim: any;

  params = {
    filter: {
      // dataFim: '',
      // dataInicio: '',
      dataInicio: new Date(),
      dataFim: new Date(),
    },
    sorting: {
      id: 'desc',
      nome: '',
      dataCriacao: '',
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }


  constructor(private consultaService: RealizarConsultaService, private msgService: ModalMsgService) { 

    
  }

  ngOnInit() {
    this.params.filter.dataInicio.setDate(1);
    this.updateResult();
  }

  changeOrder() {
    this.updateResult();
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.updateResult();
  }

  nextPage() {
    this.updateResult();
  }

  updateResult(){
    this.params.data = new Date();
    this.consultaService.listarConsultaLote(this.params).then(r => {
      this.total = r.total || 0;
      this.listaResultado = r.lista || [];
    });
  }

  setDataInicio(date, update = true) {
    date = this.params.filter.dataInicio.getTime(),
    this.pesquisaDataInicio = date;
    if (update) this.updateResult();
  }

  setDataFim(date, update = true) {
    date = this.params.filter.dataFim.getTime(),
    this.pesquisaDataFim = date;
    if (update) this.updateResult();
  }


}
